// -- The words around a payment link (22 Oct) ---------------------------------
//
// A bare link from an unsaved number reads as spam to the customer and to the
// carrier; the shop name, the reason and the amount are what make it legible.
//
// Until 22 Oct every ticket payment text said "your bike is ready for pickup",
// which is wrong for a special-order deposit or a prepayment at drop-off. Now
// it says so only when the ticket's status is one the shop put in its Pickup
// category (Settings, Workflow). Anything else, including a status the shop
// never categorised, gets wording that is true either way.
//
// Pure, so server/scripts/check-payment-text.js can run it.
export function paymentTextBody({ firstName, bike, shopName, amount, total, paidToDate, hasTicket, description, readyForPickup }) {
  const name = firstName || 'there';
  const shop = shopName || 'our shop';
  const amountStr = `$${Number(amount).toFixed(2)}`;
  if (!hasTicket) {
    return `Hi ${name}, here's a secure payment link from ${shop} for ${amountStr}${description ? ` — ${description}` : ''}:`;
  }
  const thing = bike || 'bike';
  const shopEnd = /[.!?]$/.test(shop) ? '' : '.';
  const label = paidToDate > 0 ? 'remaining balance' : 'balance';
  const isPartial = total > 0 && Math.abs(total - Number(amount)) > 0.01;
  if (readyForPickup) {
    if (isPartial) {
      return `Hi ${name}, your ${thing} is ready for pickup at ${shop}${shopEnd} You can pay ${amountStr} toward your $${total.toFixed(2)} ${label} here:`;
    }
    return `Hi ${name}, your ${thing} is ready for pickup at ${shop}${shopEnd} Your ${label} is ${amountStr}. You can pay securely here:`;
  }
  if (isPartial) {
    return `Hi ${name}, this is ${shop} about your ${thing}. You can pay ${amountStr} toward your $${total.toFixed(2)} ${label} securely here:`;
  }
  return `Hi ${name}, this is ${shop} about your ${thing}. Your ${label} is ${amountStr}. You can pay securely here:`;
}
